<div class="mt-xl-10 mt-2">
  <om-terms-of-service [beneficiary]="user" [signer]="signer" nextActionButtonText="Next" (nextAction)="onSubmit()">
  </om-terms-of-service>
</div>
